import Vue from "vue";
/**
 * setting
 * @method setTag
 * @method setContactNumber
 * @method setDelimeter
 * @method setRequestChannel
 * @method setIntervalTime
 * @method clearOtp
 * action
 * @method show
 * @method hide
 * @method showError
 * set event callback
 * @method onClickClose
 * @method onHidden
 * @method onSubmitOTP
 * event
 * @event sendCallbackOk
 * @event sendCallbackHidden
 * @event sendCallbackSubmitOTP
 */
export function OtpModalController () {
    this.tag = '',

    this.contactNumber = '';
    this.delimeter = '-';
    this.intervalTime = '';
    this.requestChannel = '';

    this.isShowError = false;
    this.errMsg = '';

    this.busModal = new Vue();

    this.callbackClose = null;
    this.callbackHidden = null;
    this.callbackSubmitOTP = null;
    this.callbackError = null;

    //#region setter
    this.setTag = function(tag) {
        this.tag = tag;
        return this;
    };
    //Otp setter
    this.setContactNumber = function (contactNumber) {
        this.contactNumber = contactNumber;
        return this;
    };
    this.setDelimeter = function (delimeter) {
        this.delimeter = delimeter || this.delimeter;
        return this;
    };
    this.setRequestChannel = function (requestChannel) {
        this.requestChannel = requestChannel;
        return this;
    };
    this.setIntervalTime = function (intervalTime) {
        this.intervalTime = intervalTime;
        return this;
    };
    this.clearOtp = function () {
        this.tag = '';
        this.contactNumber = '';
        this.delimeter = '-';
        this.intervalTime = 0;
        this.requestChannel = '';
        this.isShowError = false;
        this.errMsg = '';
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            tag: this.tag,
            contactNumber: this.contactNumber,
            delimeter: this.delimeter,
            intervalTime: this.intervalTime,
            requestChannel: this.requestChannel,
        };
        this.busModal.$emit('show', config);
    };
    this.startOtp = function() {
        var configStart = {
            tag: this.tag,
            contactNumber: this.contactNumber,
            delimeter: this.delimeter,
            intervalTime: this.intervalTime,
            requestChannel: this.requestChannel,
        };
        this.busModal.$emit('startOtp', configStart);
    };
    this.hide = function() {
        this.busModal.$emit('hide');
    };
    this.showError = function (err) {
        console.log('this.showError',err);
        
        var error = {
            isShow: true,
            err: err,
        }

        this.busModal.$emit('showError', error);
    };
    //#endregion method

    //#region event
    this.onClickClose = function(callback) {
        if (typeof callback == 'function') {
            this.callbackClose = callback;
        }
    };
    this.onHidden = function(callback) {
        if (typeof callback == 'function') {
            this.callbackHidden = callback;
        }
    };
    this.onSubmitOTP = function (callback) {
        if(typeof callback == 'function') {
            this.callbackSubmitOTP = callback;
        }
    };
    this.sendCallbackClose = function(data) {
        if (typeof this.callbackClose == 'function') {
            this.callbackClose(data);
        }
    };
    this.sendCallbackHidden = function(data) {
        if (typeof this.callbackHidden == 'function') {
            this.callbackHidden(data);
        }
    };
    this.sendCallbackSubmitOTP = function (data) {
        if (typeof this.callbackSubmitOTP == 'function') {
            this.callbackSubmitOTP(data);
        }
    };
    this.onError = function(callback) {
        if (typeof callback == 'function') {
            this.callbackError = callback;
        }
    };
    this.sendCallbackError = function (data) {
        if (typeof this.callbackError == 'function') {
            this.callbackError(data);
        }
    };
    //#endregion event
}
